export default "__VITE_ASSET__BVrX2xRv__"